<template>
  <section id="lit-bto">
    <h1 id="bto-title">オーダーメード・ブレスレット作成</h1>

    <div id="bto-panel-loading" v-if="is_loading">
      loading...<br />
      <svg class="loading-icon" viewBox="0 0 24 24">
        <path
          d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z"
        />
      </svg>
    </div>

    <div
      id="bto-panel"
      :class="is_loading ? 'opacity-0 pointer-events-none' : 'opacity-100'"
    >
      <div id="bto-panel-design">
        <PanelDesignCustomize>
          <template #design-customize-size>
            <DesignCustomizeSize
              :jewellery-item-id="accessoryItem.jewelleryItemId"
              :jewellery-item-code="accessoryItem.itemCode"
              :jewellery-type-code="accessoryItem.typeCode"
              :size-data-list="accessoryItem.sizeDataList"
              :design-id="design_id_list"
            />
          </template>

          <template #design-customize-select>
            <DesignCustomizeSelect
              :recommended-select="recommended_select"
              :assets-route="assetsRoute"
            />
          </template>

          <template #design-customize-parts>
            <DesignCustomizeParts
              :jewellery-item-id="accessoryItem.jewelleryItemId"
              :jewellery-item-code="accessoryItem.itemCode"
              :jewellery-type-name="accessoryItem.typeName"
              :type-arrange="type_arrange"
              :default-parts-types="available_part_types"
              :design-id="design_id_list"
              :size-name-list="size_name_list"
              :coordinate="coordinate"
              :parts-info="parts_info"
              :assets-route="assetsRoute"
            />
          </template>
        </PanelDesignCustomize>
      </div>

      <div id="bto-panel-parts">
        <PanelPartsPalette>
          <template #parts-info>
            <PartsPaletteInfo :parts-info="parts_info" />
          </template>

          <template #parts-label>
            <PartsPaletteLabel
              :parts-label="parts_label"
              :label-category="label_category"
            />
          </template>

          <template #parts-list>
            <PartsPaletteList
              :parts-info="parts_info"
              :parts-sort-num="parts_sort_num"
              :jewellery-item-id="accessoryItem.jewelleryItemId"
              :jewellery-item-code="accessoryItem.itemCode"
              :design-id="design_id_list"
              :coordinate="coordinate"
            />
          </template>
        </PanelPartsPalette>
      </div>

      <div id="bto-panel-info">
        <PanelAccessoryInfo :design-name="design_name" :imgurl="uri">
          <template #accessory-info-chart>
            <AccessoryInfoChart />
          </template>

          <template #accessory-info-parts-list>
            <AccessoryInfoPartsList :parts-info="parts_info" />
          </template>
        </PanelAccessoryInfo>
      </div>

      <div id="bto-panel-result">
        <PanelBtoResult
          :bto-item-id="bto_item_id"
          :jewellery-item-id="accessoryItem.jewelleryItemId"
          :jewellery-item-code="accessoryItem.itemCode"
        />
      </div>
    </div>
  </section>
</template>

<script>
import PanelAccessoryInfo from "@/components/BtoPanel/PanelAccessoryInfo.vue";
import AccessoryInfoChart from "@/components/BtoPanel/AccessoryInfoChart.vue";
import AccessoryInfoPartsList from "@/components/BtoPanel/AccessoryInfoPartsList.vue";

import PanelBtoResult from "@/components/BtoPanel/PanelBtoResult.vue";

import PanelDesignCustomize from "@/components/BtoPanel/PanelDesignCustomize.vue";
import DesignCustomizeSize from "@/components/BtoPanel/DesignCustomizeSize.vue";
import DesignCustomizeSelect from "@/components/BtoPanel/DesignCustomizeSelect.vue";
import DesignCustomizeParts from "@/components/BtoPanel/DesignCustomizeParts.vue";

import PanelPartsPalette from "@/components/BtoPanel/PanelPartsPalette.vue";
import PartsPaletteInfo from "@/components/BtoPanel/PartsPaletteInfo.vue";
import PartsPaletteLabel from "@/components/BtoPanel/PartsPaletteLabel.vue";
import PartsPaletteList from "@/components/BtoPanel/PartsPaletteList.vue";

import RequestController from "@/mixins/BtoPanel/ControllerRequest.js";
import accessoryItemRestRepository from "@/mixins/BtoPanel/RepositoryAccessoryItemRest.js";

import { mapActions, mapMutations } from "vuex";

export default {
  name: "TheBTOPanel",

  components: {
    PanelPartsPalette,
    PanelDesignCustomize,
    DesignCustomizeSize,
    DesignCustomizeSelect,
    DesignCustomizeParts,
    PanelAccessoryInfo,
    AccessoryInfoChart,
    AccessoryInfoPartsList,
    PanelBtoResult,
    PartsPaletteInfo,
    PartsPaletteLabel,
    PartsPaletteList,
  },

  mixins: [RequestController, accessoryItemRestRepository],

  data() {
    return {
      accessoryItem: {},
      parts_info: {},
      parts_type_info: {},
      parts_sort_num: {},
      parts_label: {},
      label_category: {},
      uri: "",
      design_name: "",
      parts_selected_list: {},
      type_arrange: {},
      available_part_types: {},
      design_id_list: {},
      recommended_select: {},
      bto_item_id: "",
      size_name_list: {},
      coordinate: {},
      is_loading: true,
      assetsRoute: null,
      requestCodes: {},
    };
  },

  computed: {
    current_parts_id() {
      return this.$store.state.current_parts_id;
    },

    current_size_id() {
      return this.$store.state.current_size_id;
    },

    accessory_item_data: {
      get() {
        return this.accessoryItem;
      },
      set(data) {
        this.accessoryItem = data;
      },
    },
  },

  created() {
    this.requestCodes = this.getRequestCode();

    // GETリクエストがなければHomeにリダイレクトする
    if (!this.requestCodes.code) {
      try {
        () => {
          throw "Accessory not found";
        };
      } catch (error) {
        void error.message;
        window.location.href = process.env.VUE_APP_LIT_URL_HOME;
      }
    }
  },

  mounted() {
    /**
     * 初期化
     * @type {[type]}
     */
    this.init().then(
      (item) => {
        //data
        this.accessory_item_data = item.item;
        this.coordinate = item.coordinate;
        this.parts_info = item.parts_info;
        this.parts_sort_num = item.parts_sort_num;
        this.parts_type_info = item.parts_type_info;
        this.parts_label = item.label;
        this.label_category = item.label_category;
        this.uri = item.imgurl;
        this.bto_item_id = item.bto_item_id;
        this.design_name = item.item.designName + item.item.typeName;
        this.recommended_select = item.recommended_select;
        this.available_part_types =
          item.parts_list_by_size.available_part_types;
        this.type_arrange = item.parts_list_by_size.type_arrange;
        item.item.sizeDataList.forEach((data) => {
          this.parts_selected_list[data.accessorySize_id] = data.beads;
          this.size_name_list["size_" + data.accessorySize_id] = data.name;
        });
        this.extractDesignIdList(item.item.sizeDataList);

        //vuex
        this.$store.commit("update_size_id", item.item.currentSizeId);
        this.$store.commit(
          "update_id_holder",
          item.parts_list_by_size.id_holder
        );
        this.$store.commit(
          "update_selected_parts_class",
          this.available_part_types
        );
        this.setDefaultLabelCode();

        //価格情報を取得
        this.update_bto_result({
          jewelleryItemId: this.accessory_item_data.jewelleryItemId,
          itemCode: this.accessory_item_data.itemCode,
          designId: this.design_id_list,
        });

        this.is_loading = false;
      },
      (error) => {
        // リクエストがなければHomeにリダイレクトする
        void error.message;
        window.location.href = process.env.VUE_APP_LIT_URL_HOME;
      }
    );

    this.assetsRoute = process.env.VUE_APP_LIT_ASSET_ROUTE;
  },

  methods: {
    openLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 10 * 1000);
    },

    /**
     * HTTPリクエストを受け取って、REST-APIに送るコードを返す
     * @return {[type]} [description]
     */
    getRequestCode() {
      let remake = this.getRemakeCode(this.$route.query) ? true : false;

      let code = remake
        ? this.getRemakeCode(this.$route.query)
        : this.getAccessoryCode(this.$route.query);

      return {
        code: code,
        remake: remake,
      };
    },

    /**
     * 商品データからデザインIDリストを抽出してセットする
     * @param  {[type]} sizedata_list [description]
     * @return {[type]}               [description]
     */
    extractDesignIdList(sizedata_list) {
      let ids = {};
      sizedata_list.forEach((item) => {
        let key = "size_" + item.accessorySize_id;
        ids[key] = item.accessoryDesign_id;
      });
      this.design_id_list = ids;
    },

    /**
     * HTTPリクエストを受け取って、ラベルの選択状態を更新する
     */
    setDefaultLabelCode() {
        let lkey;
        let lval;
        let ret = 'all';

        if ('lc' in this.$route.query) {
            let labels = this.$route.query.lc.split('_');
            lkey = labels[0] ?? null;
            lval = this.$route.query.lc;

            if (
                (lkey in this.parts_label)
                && (lval in this.parts_label[lkey])
            ) {
                ret = this.parts_label[lkey][lval].labelCode;
            }
        }

        this.updateSelectedLabelCode(ret);
    },

    /**
     * REST-APIからBTO商品データを取得して返す
     * @return {[type]} [description]
     */
    async init() {
      let item = await this.getAccessoryItem(this.requestCodes);

      // リクエストがなければHomeにリダイレクトする
      if (null === item.item) {
        throw new Error("Accessory not found");
      } else {
        return item;
      }
    },
    ...mapActions(["update_bto_result"]),
    ...mapMutations(["updateSelectedLabelCode"]),
  },
};
</script>

<style scoped lang="stylus">

#bto-panel
  color: #6d6d6d;
  width: 100%;
  display: grid;
  grid-gap: 0;

#bto-title
  background-image: url($css-assets bg_h1_bto_01.jpg)
  background-position: left top
  background-repeat: no-repeat
  height: 100px
  white-space: nowrap
  text-indent:950px
  overflow: hidden
  margin: 0 auto

#lit-bto
  width: 100%

@screen lg
  #lit-bto
    max-width: 950px
    margin: auto
  #bto-title
    width: 950px
  #bto-panel-design
    padding-top: 15px
    padding-left: 1em
    padding-right: 1em
  #bto-panel-result
    padding-left: 1em
    padding-right: 1em
  #bto-panel-parts
    padding-top: 15px


@css {
  #bto-panel {
    @apply grid grid-areas-mobile lg:grid-areas-desktop grid-cols-mobile lg:grid-cols-desktop transition transition-opacity duration-700 ease-in-out
  }
  #bto-panel-design {
    @apply grid-in-design
  }
  #bto-panel-info {
    @apply grid-in-info
  }
  #bto-panel-parts {
    @apply grid-in-parts
  }
  #bto-panel-result {
    @apply grid-in-result
  }
  #bto-panel-loading {
    @apply mx-auto my-4 text-center
  }
  #bto-panel-loading .loading-icon {
    @apply animate-bounce h-16 w-16 my-4 mx-auto fill-current text-gray-400
  }
}
</style>
